import { question_dashboard } from "@Modules/Dashboard/configs/constants";
import dashboardReducer from "@Modules/Dashboard/Store/reducers";
import list_question from "./reducers/question";

export default {
  [question_dashboard]: list_question,
  dashboard: dashboardReducer,
};
